// Production builds load one content-hashed main bundle; a different hash in the
// deployed index.html means this tab is running a superseded build.
const MAIN_BUNDLE = /\/static\/js\/main\.[0-9a-f]+\.js/;

type Listener = () => void;

const listeners = new Set<Listener>();
let updateAvailable = false;
let pending: Promise<boolean> | undefined;

const loadedBundle = (): string | undefined => {
  for (const script of Array.from(document.scripts)) {
    const match = script.src.match(MAIN_BUNDLE);
    if (match) return match[0];
  }
  return undefined;
};

export const isAppUpdateAvailable = (): boolean => updateAvailable;

export const subscribeToAppUpdate = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const checkForAppUpdate = (): Promise<boolean> => {
  if (updateAvailable) return Promise.resolve(true);
  const loaded = loadedBundle();
  // Development and test builds have no hashed bundle to compare.
  if (!loaded) return Promise.resolve(false);
  if (pending) return pending;
  pending = fetch('/index.html', { cache: 'no-store' })
    .then((response) => (response.ok ? response.text() : ''))
    .then((html) => {
      const deployed = html.match(MAIN_BUNDLE)?.[0];
      if (deployed && deployed !== loaded) {
        updateAvailable = true;
        listeners.forEach((listener) => listener());
      }
      return updateAvailable;
    })
    .catch(() => false)
    .finally(() => {
      pending = undefined;
    });
  return pending;
};
